import { render, staticRenderFns } from "./loading.page.component.vue?vue&type=template&id=ca728bd2"
import script from "./loading.page.component.vue?vue&type=script&lang=js"
export * from "./loading.page.component.vue?vue&type=script&lang=js"
import style0 from "./loading.page.component.vue?vue&type=style&index=0&id=ca728bd2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports